import UiElement from '../../../shared/ui-element/ui-element';

import { detect } from '../../utils/browser';

import './installer-download-balloon.scss';

const supportedBrowsers = ['chrome', 'safari', 'firefox'];
const targetChromeVersion = '117.0.0';

export default class InstallerDownloadBalloon extends UiElement {
  ui = {
    balloon: '.installer-download-balloon',
    balloonWrapper: '.installer-download-balloon__wrapper',
  };

  static visibilityClass = 'installer-download-balloon__wrapper_visible';

  onInit() {
    const { name: browserName, version: currentVersion } = detect();
    const isChromeVersionLateAug2023 =  Boolean(
      this.compareMajorVersions(currentVersion, targetChromeVersion) && browserName === 'chrome'
    );

    this.isSupportedBrowser = supportedBrowsers.includes(browserName);

    if (isChromeVersionLateAug2023) {
      this.ui.balloonWrapper.classList.add('installer-download-balloon__wrapper_chrome_upper-position');
    } else {
      this.ui.balloon.classList.add(`installer-download-balloon_${browserName}`);
      this.ui.balloonWrapper.classList.add(`installer-download-balloon__wrapper_${browserName}`);
    }
  }

  show() {
    if (this.isSupportedBrowser) {
      this.ui.balloonWrapper.classList.add(InstallerDownloadBalloon.visibilityClass);
    }
  }

  hide() {
    this.ui.balloonWrapper.classList.remove(InstallerDownloadBalloon.visibilityClass);
  }

  compareMajorVersions(currentVersion, targetVersion) {
    if (typeof currentVersion !== 'string' || typeof targetVersion !== 'string') {
      return null;
    }

    const currentMajor = Number(currentVersion.split('.')[0]);
    const targetMajor = Number(targetVersion.split('.')[0]);

    return currentMajor >= targetMajor;
  }
}
